import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, setToken, saveUser } from "@/lib/api";
import { ShieldCheck, Lock, Mail, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function AdminLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/auth/admin-login", { email, password });
      setToken(res.data.token); saveUser(res.data.user);
      toast.success("Admin access granted");
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid credentials");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#0B1120] text-white flex items-center justify-center p-6 relative overflow-hidden">
      <div className="absolute inset-0 grain opacity-30" />
      <div className="w-full max-w-md relative z-10">
        <Link to="/login" data-testid="back-to-login" className="inline-flex items-center gap-1.5 text-slate-400 hover:text-white text-sm mb-8">
          <ArrowLeft className="w-4 h-4" /> Back to user sign-in
        </Link>

        <div className="bg-slate-900/60 border border-slate-800 backdrop-blur-xl rounded-2xl p-8">
          <div className="flex items-center gap-2 mb-6">
            <div className="w-10 h-10 rounded-xl bg-violet-500/20 border border-violet-500/40 flex items-center justify-center">
              <ShieldCheck className="w-5 h-5 text-violet-400" />
            </div>
            <div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-violet-400">Admin Console</div>
              <h1 className="font-display font-black text-2xl">Root access</h1>
            </div>
          </div>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400">Admin email</label>
              <div className="mt-1.5 relative">
                <Mail className="w-4 h-4 absolute left-3.5 top-3.5 text-slate-500" />
                <input
                  data-testid="admin-email-input"
                  type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                  placeholder="admin@lms.io"
                  className="w-full pl-10 pr-4 py-3 rounded-xl bg-slate-950 border border-slate-800 focus:border-violet-500 outline-none text-sm text-white"
                />
              </div>
            </div>
            <div>
              <label className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400">Password</label>
              <div className="mt-1.5 relative">
                <Lock className="w-4 h-4 absolute left-3.5 top-3.5 text-slate-500" />
                <input
                  data-testid="admin-password-input"
                  type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  className="w-full pl-10 pr-4 py-3 rounded-xl bg-slate-950 border border-slate-800 focus:border-violet-500 outline-none text-sm text-white"
                />
              </div>
            </div>
            <button
              data-testid="admin-login-submit"
              disabled={loading}
              className="w-full py-3 rounded-full bg-violet-600 hover:bg-violet-700 disabled:opacity-50 font-semibold transition-colors"
            >
              {loading ? "Verifying…" : "Enter console"}
            </button>
          </form>
          <p className="mt-5 text-xs text-slate-500">Restricted area. All actions are logged.</p>
        </div>
      </div>
    </div>
  );
}
